import { Box, BoxProps } from '@mui/material';

export interface IconProps extends BoxProps {
  color?: string;
  size?: number;
  viewBox?: string;
}

export const Icon = ({ color = '#B9DDFF', size = 28, viewBox = '0 0 28 28', sx, children, ...other }: IconProps) => (
  <Box
    component="svg"
    color={color}
    width={size}
    height={size}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    sx={{
      display: 'inline-block',
      flexShrink: 0,
      ...sx,
    }}
    {...other}
  >
    {children}
  </Box>
);
